<template>
  <div class="term-tabs-wrapper">
    <template v-if="'success' == status">
      <TermTabsItems
        :style="style"
        :tabs="items"
        :logged_in_id="loggedInUserID"
        :actions="actions"
      />
      <TermsFollowModal v-if="showModal" :onClose="closeModal" />
    </template>
    <div class="mb-6 md:px-2 px-0" v-else>
      <div class="animate-pulse">
        <div class="h-16 w-full">
          <div class="flex-1 space-y-4 py-1">
            <div class="h-3 bg-lightest-gray rounded"></div>
            <div class="space-y-2">
              <div class="grid grid-cols-2 gap-4">
                <div class="h-2 bg-lightest-gray rounded col-span-1"></div>
                <div class="h-2 bg-lightest-gray rounded col-span-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import store from "@/store";
import { ref, computed } from "vue";
import { useQuery } from "vue-query";
import TermTabsItems from "@/components/TermTabsItems.vue";
import TermsFollowModal from "@/components/TermsFollowModal.vue";

export default {
  name: "TermTabs",
  props: {
    params: Object,
  },
  components: {
    TermTabsItems,
    TermsFollowModal,
  },
  setup(props) {
    const showModal = ref(false);
    const terms__in = ref(props.params.terms__in || "");
    const style = ref(props.params.style || "PostList");

    const loggedInUserID = computed(() => {
      if (store.state.localSettings && store.state.localSettings.id)
        return Number(store.state.localSettings.id);
      return 0;
    });

    const requestAPI = () => {
      return API.requestTermTabs({
        ...(!loggedInUserID.value ? { terms__in: terms__in.value } : {}),
      });
    };

    const { status, data, refetch } = useQuery(
      `termTabsQuery_${loggedInUserID.value}`,
      requestAPI
    );

    const items = computed(() =>
      data.value && data.value.data ? data.value.data : []
    );

    const handleShowModal = () => {
      showModal.value = true;
    };

    const closeModal = () => {
      refetch.value();
      showModal.value = false;
    };

    const actions = {
      show_follow_modal: {
        icon_name: "plus",
        handler: handleShowModal,
      },
    };

    return {
      style,
      items,
      status,
      actions,
      showModal,
      closeModal,
      loggedInUserID,
    };
  },
};
</script>
